/**
 * Environment Configuration
 * 
 * This is the SINGLE SOURCE OF TRUTH for all frontend environment variables.
 * All env vars are injected at BUILD TIME via Vite's import.meta.env.
 * 
 * For local development: Use frontend/.env.local (gitignored)
 * For Docker: Pass as --build-arg when building the image
 * For CI/CD: Use GitHub Environment variables as build args
 * 
 * IMPORTANT: These values are baked into the bundle at build time.
 * Changing them requires a rebuild.
 */

/**
 * Firebase Configuration
 * These are PUBLIC values (safe to include in bundle) but environment-specific.
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
} as const;

/**
 * API Configuration
 * The base URL for all API and SSE requests.
 * 
 * Local: http://localhost:3000
 * Beta: https://<CloudFrontDomain> (same-origin, includes /api/* routing)
 * Prod: https://<CloudFrontDomain>
 */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || '',
} as const;

/**
 * Combined environment configuration export
 */
export const env = {
  apiBaseUrl: apiConfig.baseUrl,
  firebase: firebaseConfig,
  
  // Helper to check if Firebase is properly configured
  isFirebaseConfigured: Boolean(
    firebaseConfig.apiKey && 
    firebaseConfig.projectId && 
    firebaseConfig.appId
  ),
  
  // Helper to check if API is properly configured
  isApiConfigured: Boolean(apiConfig.baseUrl),
  
  // Development mode
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

// Log configuration status in development (helpful for debugging)
if (import.meta.env.DEV) {
  console.log('[env] Configuration status:', {
    apiBaseUrl: env.apiBaseUrl || '(not set)',
    firebaseConfigured: env.isFirebaseConfigured,
    firebaseProjectId: firebaseConfig.projectId || '(not set)',
    mode: env.mode,
  });
}

export default env;
